export default __webpack_public_path__ + "static/buymeabeer-2037d1eb7a1f47872d1bf8a6182a63c4.png";